// extracted by css-extract-rspack-plugin
export default {"icon":"DashboardAveragePricePerClick-module__icon--uAQO9"};